import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgProfilePictureIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 108,
	height: 60,
	viewBox: "0 0 108 60",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 52,
			cy: 30,
			r: 24.25,
			fill: "white",
			stroke: "#BCA4FF",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 52,
			cy: 30,
			r: 29.25,
			stroke: "#E0DEF1",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("mask", {
			id: "mask0_5107_65032",
			style: { maskType: "alpha" },
			maskUnits: "userSpaceOnUse",
			x: 27,
			y: 5,
			width: 50,
			height: 50,
			children: /* @__PURE__ */ _jsx("circle", {
				cx: 52,
				cy: 30,
				r: 24.25,
				fill: "#BCA4FF",
				stroke: "#BCA4FF",
				strokeWidth: 1.5
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			mask: "url(#mask0_5107_65032)",
			children: /* @__PURE__ */ _jsx("rect", {
				x: 10,
				y: 39,
				width: 84,
				height: 84,
				rx: 42,
				fill: "#BCA4FF"
			})
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 41,
			y: 14,
			width: 22,
			height: 22,
			rx: 11,
			fill: "#BCA4FF"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 9,
			cy: 10,
			r: 4.25,
			stroke: "#CAEDDA",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 2.5,
			cy: 23.5,
			r: 2.5,
			fill: "#CAEDDA"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 97.0036,
			cy: 32.0047,
			r: 4.25,
			transform: "rotate(142.884 97.0036 32.0047)",
			stroke: "#BCA4FF",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 104.498,
			cy: 44.5024,
			r: 1.75,
			transform: "rotate(142.884 104.498 44.5024)",
			stroke: "#BCA4FF",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 91.1019,
			cy: 48.1016,
			r: .75,
			transform: "rotate(142.884 91.1019 48.1016)",
			fill: "#CAEDDA",
			stroke: "#BCA4FF",
			strokeWidth: 1.5
		})
	]
});
export default SvgProfilePictureIcon;
